export const PageText = {
  _1: 'Pricing',
  _2: 'Try aircheckr with our “free” plan or start directly with the “basic” or “enterprise” options.'
};

export const Categories = {
  _1: {
    title: 'Choose a plan',
    subcategories: [
      {
        key: 0,
        subtitle: 'The proof of the pudding is in the eating',
        text: 'Try aircheckr out through our free plan and learn in detail what aircheckr can mean for you. It is without any obligation and has no end date. Don\'t hesitate to <a href="/contact">contact us</a> if you want to upgrade your plan. We are also happy to help you with your specific air quality questions or with the effective integration of aircheckr into your product or test case.'
      }
    ]
  },
  _2: {
    title: 'Why does aircheckr cost what it costs?',
    subcategories: [
      {
        key: 0,
        subtitle: 'Air quality matters',
        text: 'Air quality is a hot topic. Many people are concerned, but feel helpless to act accordingly. aircheckr turns air quality into something positive. People are no longer defenceless. aircheckr empowers your customers to actively or passively make better decisions and take actions in order to breathe better air.'
      },
      {
        key: 1,
        subtitle: 'Detailed air quality data',
        text: 'aircheckr is detailed, fast, simple to interpret, high-quality and applied, opening up a huge amount of possibilities for daily use by individuals and integration in businesses.'
      }
    ]
  }
};

export const PriceOptions = {
  _1: {
    type: 'free',
    header: {
      icon: 'leaf',
      title: 'Free',
      'meta': 'for non-commercial use'
    },
    body: {
      price: {
        amount: '0',
        currency: 'euro',
        after: 'always'
      },
      features: [
        {
          text: 'no commitment'
        },
        {
          text: 'up to 1.500',
          meta: 'API calls/month'
        },
        {
          text: 'email support'
        }
      ],
      cta: {
        text: 'Sign up',
        linkAddress: '/signup',
        type: 'soft'
      }
    }
  },
  _2: {
    type: 'pro',
    header: {
      icon: 'tree',
      title: 'Pro',
      'meta': 'for commercial use'
    },
    body: {
      price: "Contact<br/>Us",
      features: [
        {
          text: 'customised solution'
        },
        {
          text: 'unlimited',
          meta: 'incl. statistics'
        },
        {
          text: 'support & insights'
        }
      ],
      cta: {
        text: 'Get in touch',
        linkAddress: '/contact',
        type: 'primary'
      }
    }
  },
  _3: {
    type: 'research',
    header: {
      icon: 'university',
      title: 'Research',
      'meta': 'for our offspring'
    },
    body: {
      price: "Contact<br/>Us",
      features: [
        {
          text: 'suitable for studies'
        },
        {
          text: 'unlimited',
          meta: 'incl. statistics'
        },
        {
          text: 'support & insights'
        }
      ],
      cta: {
        text: 'Get in touch',
        linkAddress: '/contact',
        type: 'primary-light'
      }
    }
  },
  footnotes: {
    text_1: '<strong>R&D</strong>: If you are interested to use aircheckr purely for R&D or want to use it as an input for a publication or article, please <a href="/contact">contact us</a> for an adjusted license.'
  }
}

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/pricing_page.js